import React, { useContext, useEffect, useState, useTransition } from "react";
import "./Gerenciador.scss";
import { useNavigate } from "react-router-dom";
import GlobalContext from "@context/GlobalContext";
import useLoading from "@hooks/useLoading";
import EndPointServices from "@services/ApiServices";
import Grid from "@components/grid/Grid";
import CheckBox from "@components/checkbox/CheckBox";
import mappingColumn from "@components/grid/mappingColumn";
import Button from "@components/button/Button";
import Modal from "@components/modal/Modal";
import UtilServices from "@services/UtilServices";
import MessageServices from "@services/MessageServices";
import IconSistemaDominio from "@icons/IconSistemaDominio";

const Gerenciador = () => {
  const [isPending, startTransition] = useTransition();
  const [isPendingB, startTransitionB] = useTransition();
  const [isPendingC, startTransitionC] = useTransition();
  const [isPendingD, startTransitionD] = useTransition();

  useLoading(isPending);

  //Variaveis Padrões
  const [state] = useContext(GlobalContext);
  const navigate = useNavigate();

  //Certificado / Dominio / Emprsea
  const [lstcertificado, setLstCertificado] = useState([]);
  const [lstDominio, setLstDominio] = useState([]);
  const [empresa, setEmpresa] = useState([]);
  const [empresaBKP, setEmpresaBKP] = useState([]);

  //check
  const [check, setCheck] = useState(false);

  //Relacionamento
  const [iddominio, seIdtDominio] = useState(null);
  const [idcertificado, setIdCertificado] = useState(null);
  const [idsEmpresa, setIdsEmpresa] = useState([]);

  //Modal
  const [showModal, setShowModal] = useState(false);

  //delete
  const [del, setDel] = useState([]);

  useEffect(() => {
    handleConsultaCertificado();
    handleConsultaDominio();
    handleConsultaEmpresa();
  }, []);

  function handleConsultaCertificado() {
    startTransitionC(async () => {
      let data = {
        id_usuario_guid: state.dadosusuario?.id_usuario_guid,
        id_usuario: state.dadosusuario?.id_usuario,
      };
      var retornoapi = await EndPointServices.Cliente_ConsultaCertificado(data);
      if (retornoapi?.Success) {
        setLstCertificado(retornoapi.BaseReturn.LstClasse);
      }
    });
  }
  function handleConsultaDominio() {
    startTransitionD(async () => {
      let data = {
        id_usuario_guid: state.dadosusuario?.id_usuario_guid,
        id_usuario: state.dadosusuario?.id_usuario,
      };
      var retornoapi = await EndPointServices.Cliente_ConsultaLstDominio(data);
      if (retornoapi?.Success) {
        setLstDominio(retornoapi.BaseReturn.LstClasse);
      }
    });
  }
  function handleConsultaEmpresa() {
    startTransitionB(async () => {
      let data = {
        id_usuario_guid: state.dadosusuario?.id_usuario_guid,
        id_usuario: state.dadosusuario?.id_usuario,
      };
      var retornoapi = await EndPointServices.Cliente_ConsultaEmpresa(data);
      if (retornoapi?.Success) {
        setEmpresa(retornoapi.BaseReturn.LstClasse);
        setEmpresaBKP(retornoapi.BaseReturn.LstClasse);
      }
    });
  }
  function handleFiltroEmpresa(id_dominio, id_certificado) {
    startTransitionB(async () => {
      if (id_dominio) {
        let dados = empresaBKP.filter((item) => item.id_dominio === id_dominio);
        setEmpresa(dados);
      } else if (id_certificado) {
        let dados = empresaBKP.filter(
          (item) => item.id_certificado === id_certificado,
        );
        setEmpresa(dados);
      } else {
        setEmpresa(empresaBKP);
      }
    });
  }
  function handleDeletar(flg_excluir = false) {
    if (del?.id_dominio) {
      startTransition(async () => {
        let data = {
          id_usuario_guid: state.dadosusuario?.id_usuario_guid,
          id_usuario: state.dadosusuario?.id_usuario,
          id_dominio: del?.id_dominio,
        };
        var retornoapi = await EndPointServices.Cliente_DeletaDominio(data);
        if (retornoapi?.Success) {
          MessageServices.ShowSuccess("Dominio excluido com sucesso!");
          handleConsultaDominio();
        }
      });
    } else if (del?.id_certificado) {
      startTransition(async () => {
        let data = {
          id_usuario_guid: state.dadosusuario?.id_usuario_guid,
          id_usuario: state.dadosusuario?.id_usuario,
          id_certificado: del?.id_certificado,
        };
        var retornoapi = await EndPointServices.Cliente_DeletaCertificado(data);
        if (retornoapi?.Success) {
          MessageServices.ShowSuccess("Certificado excluido com sucesso!");
          handleConsultaCertificado();
        }
      });
    } else if (del?.id_empresa) {
      startTransition(async () => {
        let data = {
          id_usuario_guid: state.dadosusuario?.id_usuario_guid,
          id_usuario: state.dadosusuario?.id_usuario,
          id_empresa: del?.id_empresa,
          flg_excluir: flg_excluir,
        };
        var retornoapi = await EndPointServices.Cliente_DeletaEmpresa(data);
        if (retornoapi?.Success) {
          MessageServices.ShowSuccess(
            `Empresa ${flg_excluir ? "excluida" : "inativada"} com sucesso!`,
          );
          handleConsultaEmpresa();
        }
      });
    }
    setShowModal(false);
  }
  function handleVinculo() {
    let dados = {
      empresa: idsEmpresa,
      id_certificado: idcertificado,
      id_dominio: iddominio,
    };

    startTransition(async () => {
      let data = {
        id_usuario_guid: state.dadosusuario?.id_usuario_guid,
        id_usuario: state.dadosusuario?.id_usuario,
        json: dados,
      };
      var retornoapi = await EndPointServices.Cliente_CadastraVinculo(data);
      if (retornoapi?.Success) {
        MessageServices.ShowSuccess("Empresas vinculadas a regra com sucesso!");
        handleConsultaCertificado();
        handleConsultaDominio();
        handleConsultaEmpresa();
        setCheck(false);
      }
    });
  }

  return (
    <div className="gerenciador row">
      <div className="col-md-9 col-12">
        <CheckBox
          checked={check}
          className="passo-1"
          onChange={(e) => {
            setCheck(e.target.checked);
            startTransitionB(async () => {
              setEmpresa(empresaBKP);
            });
          }}
          title="Selecione esta opção para associar empresas ao certificado ou sistema dominio"
        />
      </div>
      <div className="col-md-3 col-12 mt-md-0 mt-3 d-flex justify-content-md-end">
        <Button
          nome="Fazer vinculação"
          icon="<i class='fa-solid fa-link-horizontal'></i>"
          theme="2"
          className="passo-2 btn-vinculacao"
          disabled={
            !(idsEmpresa.length > 0 && (iddominio || idcertificado) && check)
          }
          onClick={() => {
            handleVinculo();
          }}
        />
      </div>
      <div className="mt-5 col-md-6 col-12">
        <div className="mb-3 justify-content-end" style={{ display: "flex" }}>
          <Button
            nome="Novo Certificado"
            icon="<i class='fa-solid fa-file-certificate'></i>"
            theme="2"
            onClick={() => {
              navigate("/RPA/Cadastro/Certificado");
            }}
          />
        </div>
        <Grid
          dadosGrid={lstcertificado}
          columns={mappingColumn.getCliente_Certificado(
            lstcertificado,
            setDel,
            setShowModal,
          )}
          {...(lstcertificado?.length > 0 && {
            pageVisible: true,
          })}
          selection={{
            allowSelectAll: false,
            mode: "multiple",
            showCheckBoxesMode: "always",
          }}
          iconTitle="<i class='fa-solid fa-file-certificate'></i>"
          title="Certificados"
          Memo={false}
          pagingStaticSize="5"
          useLoading={isPendingC}
          onSelectionChanged={(e) => {
            if (e.selectedRowKeys.length > 1) {
              e.component.selectRows([e.selectedRowKeys[1]]);
              e.component.deselectRows([e.selectedRowKeys[0]]);
            }

            setIdCertificado(e.currentSelectedRowKeys[0]?.id_certificado);
            if (e.currentSelectedRowKeys[0] && !check) {
              handleFiltroEmpresa(
                null,
                e.currentSelectedRowKeys[0]?.id_certificado,
              );
            }
            if (!e.currentSelectedRowKeys[0] && !check) {
              handleFiltroEmpresa(null, null);
            }
          }}
        />
      </div>
      <div className="mt-5 col-md-6 col-12">
        <div className="mb-3 justify-content-end" style={{ display: "flex" }}>
          <Button
            nome="Novo Dominio"
            icon="<i class='fa-solid fa-desktop'></i>"
            theme="2"
            onClick={() => {
              navigate("/RPA/Cadastro/Dominio");
            }}
          />
        </div>
        <Grid
          dadosGrid={lstDominio}
          columns={mappingColumn.getCliente_LstDominio(
            lstDominio,
            setDel,
            setShowModal,
          )}
          {...(lstDominio?.length > 0 && {
            pageVisible: true,
          })}
          selection={{
            allowSelectAll: false,
            mode: "multiple",
            showCheckBoxesMode: "always",
          }}
          iconTitle={<IconSistemaDominio />}
          title="Sistema Dominio"
          Memo={false}
          pagingStaticSize="5"
          useLoading={isPendingD}
          onSelectionChanged={(e) => {
            if (e.selectedRowKeys.length > 1) {
              e.component.selectRows([e.selectedRowKeys[1]]);
              e.component.deselectRows([e.selectedRowKeys[0]]);
            }

            seIdtDominio(e.currentSelectedRowKeys[0]?.id_dominio);
            if (e.currentSelectedRowKeys[0] && !check) {
              handleFiltroEmpresa(
                e.currentSelectedRowKeys[0]?.id_dominio,
                null,
              );
            }
            if (!e.currentSelectedRowKeys[0] && !check) {
              handleFiltroEmpresa(null, null);
            }
          }}
        />
      </div>
      <div className="mt-5">
        <div className="mb-3 justify-content-end" style={{ display: "flex" }}>
          <Button
            nome="Nova Empresa"
            icon="<i class='fa-solid fa-desktop'></i>"
            theme="2"
            onClick={() => {
              navigate("/RPA/Cadastro/Empresa");
            }}
          />
        </div>
        <Grid
          dadosGrid={empresa}
          columns={mappingColumn.getCliente_Empresa(
            empresa,
            setDel,
            setShowModal,
          )}
          {...(empresa?.length > 0 && {
            pageVisible: true,
          })}
          {...(check && {
            selection: {
              allowSelectAll: true,
              mode: "multiple",
              showCheckBoxesMode: "always",
            },
          })}
          iconTitle="<i class='fa-solid fa-users'></i>"
          title="Empresas"
          Memo={false}
          useLoading={isPendingB}
          pagingStaticSize="5"
          onSelectionChanged={(e) => {
            setIdsEmpresa(e.selectedRowKeys);
          }}
        />
      </div>
      <Modal
        showModal={showModal}
        setShowModal={setShowModal}
        title="Alerta"
        width="auto"
        button001_Nome={del?.id_empresa ? "Inativar" : "Deseja Continuar"}
        button001_onClick={() => {
          handleDeletar();
        }}
        showButton001
        button01_classname={del?.id_empresa ? "Inativar" : ""}
        {...(del?.id_empresa && {
          button002_Nome: "Excluir Definitivo",
          button002_onClick: () => {
            handleDeletar(true);
          },
          showButton002: true,
        })}
      >
        <div className="alerta">{UtilServices.stringToJsx(del?.mensagem)}</div>
      </Modal>
    </div>
  );
};

export default Gerenciador;
